module.exports = __webpack_public_path__ + "img/mineQR.b4649aee.jpg";